<div class="inner-content">
  <div class="contenedor">
    <div class="header">
      <div class="contenedor-titulo">
        <p class="headline-medium titulo">Olvidaste tu contraseña</p>
        <div class="divider"></div>
      </div>
      <p *ngIf="!correoEnviado" class="body-large">Ingresa tu correo para reestablecer tu contraseña.</p>
    </div>
    <div class="body">
      <div class="verificacion-correo" *ngIf="!correoEnviado">
        <div class="inputs" >
          <yalo-input   type="email" formError
          ngDefaultControl [formControl]="correoControl" placeholder="Correo">
          </yalo-input>
        </div>
        <div class="botones">
          <yalo-button [disabled]="correoControl.invalid || !correoEncontrado" type="primary" text="medium" (click)="retablecerPassword()">Restablecer</yalo-button>
          <yalo-button type="tertary" text="medium" (click)="cerrar()">Cancelar</yalo-button>
        </div>
      </div>
      

      <div class="correo-verificado" *ngIf="correoEnviado">
        <p class="body-large">Te enviamos un enlace a <span class="headline-x-small">{{correoControl.value}}</span> <br> para reestablecer tu contraseña. <br> 
          Si no lo encuentras revisa la bandeja de correo no deseado.
        </p>

        <div class="botones-verificado">
          <yalo-button type="primary" text="medium" (click)="irLogin()">Iniciar sesión</yalo-button>
          <div class="body-large">
            ¿No recibiste el correo?
            <a (click)="retablecerPassword()" style="cursor: pointer;">
              Reenviar correo
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>